import React from "react";
import "./AddAutovehicles.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";

const DistributionForm = ({ data, setData, errors = {}, editMode }) => {

    // actualizează câmpurile de tip dată
    const updateDate = (field, date) => {
        if (!editMode) return;
        setData((prev) => ({
            ...prev,
            [field]: date ? format(date, "yyyy-MM-dd") : ""
        }));
    };

    // actualizează câmpurile simple
    const updateField = (field, value) => {
        if (!editMode) return;
        setData((prev) => ({
            ...prev,
            [field]: value
        }));
    };

    return (
        <div className="distribution-card">
            <h3>Distribution</h3>

            {/* LAST CHANGE */}
            <h4>Last change</h4>
            <div className="distribution-row">

                {/* DATE */}
                <div className="field">
                    <label>Distribution date</label>

                    <div className="datepicker-container">

                        <DatePicker
                            id="dist-date"
                            disabled={!editMode}
                            selected={data.distribution_data ? new Date(data.distribution_data) : null}
                            onChange={(date) => updateDate("distribution_data", date)}
                            dateFormat="dd.MM.yyyy"
                            placeholderText="dd.mm.yyyy"
                            className="datepicker-input-with-icon"
                            calendarClassName="custom-calendar"
                            autoComplete="off"
                        />

                        {editMode && (
                            <span
                                className="calendar-icon-inside"
                                onClick={() => document.querySelector("#dist-date")?.focus()}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                                    <line x1="16" y1="2" x2="16" y2="6" />
                                    <line x1="8" y1="2" x2="8" y2="6" />
                                    <line x1="3" y1="10" x2="21" y2="10" />
                                </svg>
                            </span>
                        )}
                    </div>

                    {errors?.distribution_data && (
                        <span className="field-error">{errors.distribution_data}</span>
                    )}
                </div>

                {/* KM */}
                <div className="distribution-field">
                    <label>Km</label>
                    <input
                        type="number"
                        disabled={!editMode}
                        value={data.distribution_km}
                        onChange={(e) => updateField("distribution_km", e.target.value)}
                        placeholder="Ex: 120000"
                    />
                </div>

                {/* INTERVAL */}
                <div className="distribution-field">
                    <label>Interval</label>
                    <input
                        type="number"
                        disabled={!editMode}
                        value={data.distribution_interval}
                        onChange={(e) => updateField("distribution_interval", e.target.value)}
                        placeholder="Ex: 60000"
                    />
                </div>

            </div>

            {/* NEXT CHANGE */}
            <h4>Next change</h4>
            <div className="distribution-row">

                {/* ESTIMATED DATE */}
                <div className="field">
                    <label>Estimated date</label>

                    <div className="datepicker-container">

                        <DatePicker
                            id="dist-estimate-date"
                            disabled={!editMode}
                            selected={data.estimate_date_distribution ? new Date(data.estimate_date_distribution) : null}
                            onChange={(date) => updateDate("estimate_date_distribution", date)}
                            dateFormat="dd.MM.yyyy"
                            placeholderText="dd.mm.yyyy"
                            className="datepicker-input-with-icon"
                            calendarClassName="custom-calendar"
                            autoComplete="off"
                        />

                        {editMode && (
                            <span
                                className="calendar-icon-inside"
                                onClick={() => document.querySelector("#dist-estimate-date")?.focus()}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                                    <line x1="16" y1="2" x2="16" y2="6" />
                                    <line x1="8" y1="2" x2="8" y2="6" />
                                    <line x1="3" y1="10" x2="21" y2="10" />
                                </svg>
                            </span>
                        )}
                    </div>

                    {errors?.estimate_date_distribution && (
                        <span className="field-error">{errors.estimate_date_distribution}</span>
                    )}
                </div>

                {/* NEXT KM */}
                <div className="distribution-field">
                    <label>Km</label>
                    <input
                        type="number"
                        disabled={!editMode}
                        value={data.estimate_km_distribution}
                        onChange={(e) => updateField("estimate_km_distribution", e.target.value)}
                        placeholder="Ex: 180000"
                    />
                </div>

            </div>
        </div>
    );
};

export default DistributionForm;